import { z } from 'zod';

/**
 * Règles de mot de passe appliquées à l'acceptation d'invitation.
 *
 * ⚠️ Elles sont **purement front** : `POST /v1/auth/invitation/accept` n'impose
 * aucune contrainte (confirmé par Yohan le 3 septembre 2026). C'est donc le
 * seul endroit qui garantit un mot de passe correct — ne pas assouplir en
 * pensant que le back rattrapera.
 */
export const PASSWORD_MIN_LENGTH = 8;

export const passwordSchema = z
  .string()
  .min(PASSWORD_MIN_LENGTH, { message: `Au moins ${PASSWORD_MIN_LENGTH} caractères` })
  .regex(/[A-Z]/, { message: 'Au moins une majuscule' })
  .regex(/\d/, { message: 'Au moins un chiffre' });
